import React from 'react';
import { useToastStore } from '../../stores/toastStore';

// Toast样式配置
const toastStyles = {
  error: {
    bg: 'bg-red-50',
    border: 'border-red-200',
    text: 'text-red-600',
    icon: '❌',
  },
  success: {
    bg: 'bg-green-50',
    border: 'border-green-200',
    text: 'text-green-600',
    icon: '✅',
  },
  info: {
    bg: 'bg-blue-50',
    border: 'border-blue-200',
    text: 'text-blue-600',
    icon: '💡',
  },
};

const Toast: React.FC = () => {
  const { toasts, removeToast } = useToastStore();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[200] flex flex-col gap-2 w-[90%] max-w-[400px]">
      {toasts.map((t) => {
        const style = toastStyles[t.type];
        return (
          <div
            key={t.id}
            className={`${style.bg} ${style.border} ${style.text} px-4 py-3 rounded-xl border shadow-lg text-[14px] font-medium flex items-center justify-between animate-slide-down`}
          >
            <span className="flex items-center gap-2">
              <span>{style.icon}</span>
              <span>{t.message}</span>
            </span>
            <button
              onClick={() => removeToast(t.id)}
              className="ml-2 opacity-60 hover:opacity-100 transition-opacity"
            >
              ✕
            </button>
          </div>
        );
      })}
    </div>
  );
};

export default Toast;